export default __webpack_public_path__ + "static/IBMPlexSans-Light-Latin1-e5b7f5835bf8b91304bfc21b47612479.woff";